import { render, staticRenderFns } from "./full-site-footer.vue?vue&type=template&id=ba0bb79e"
import script from "./full-site-footer.vue?vue&type=script&lang=js"
export * from "./full-site-footer.vue?vue&type=script&lang=js"
import style0 from "./full-site-footer.vue?vue&type=style&index=0&id=ba0bb79e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports